module.exports = __webpack_public_path__ + "static/media/Judit-profil3.e6f158e9.JPG";